import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { StatementHeadlines } from '/src/lib/models';
import type { TGetStatementHeadlinesRequest, TGetStatementHeadlinesResponse } from '/src/lib/types';

export class StatementHeadlinesService {
  private static _interceptor = (headlines: StatementHeadlines) => {
    let balances = [];

    // End-of-month calcs
    if (headlines.month) {
      headlines.month.totalRevenue = headlines.month.appliedToFees + headlines.month.appliedToInterest;
      headlines.month.netRevenue = headlines.month.totalRevenue - headlines.month.managementFees;
      headlines.month.totalUnpaidRevenue = headlines.month.feeBalance + headlines.month.interestBalance;
      balances = [
        headlines.month.account.amountInvested,
        -Math.abs(headlines.month.principalBalance),
        headlines.month.appliedToFees,
        headlines.month.appliedToInterest,
        -Math.abs(headlines.month.managementFees),
        -Math.abs(headlines.month.account.amountReturned),
      ];
      headlines.month.balances = balances.reduce((prev, curr) => prev + curr);
    }

    // YTD calcs
    if (headlines.ytd) {
      headlines.ytd.totalRevenue = headlines.ytd.appliedToFees + headlines.ytd.appliedToInterest;
      headlines.ytd.netRevenue = headlines.ytd.totalRevenue - headlines.ytd.managementFees;
      headlines.ytd.totalUnpaidRevenue = headlines.ytd.feeBalance + headlines.ytd.interestBalance;
      balances = [
        headlines.ytd.account.amountInvested,
        -Math.abs(headlines.ytd.principalBalance),
        headlines.ytd.appliedToFees,
        headlines.ytd.appliedToInterest,
        -Math.abs(headlines.ytd.managementFees),
        -Math.abs(headlines.ytd.account.amountReturned),
      ];
      headlines.ytd.balances = balances.reduce((prev, curr) => prev + curr);
    }

    // All-time calcs
    if (headlines.alltime) {
      headlines.alltime.totalRevenue = headlines.alltime.appliedToFees + headlines.alltime.appliedToInterest;
      headlines.alltime.netRevenue = headlines.alltime.totalRevenue - headlines.alltime.managementFees;
      headlines.alltime.totalUnpaidRevenue = headlines.alltime.feeBalance + headlines.alltime.interestBalance;
      balances = [
        headlines.alltime.account.amountInvested,
        -Math.abs(headlines.alltime.principalBalance),
        headlines.alltime.appliedToFees,
        headlines.alltime.appliedToInterest,
        -Math.abs(headlines.alltime.managementFees),
        -Math.abs(headlines.alltime.account.amountReturned),
      ];
      headlines.alltime.balances = balances.reduce((prev, curr) => prev + curr);
    }

    // Return the data
    return headlines;
  };

  /**
   * Get Statement Headlines
   * @returns Headline
   * @throws ApiError
   */
  public static async get(req: TGetStatementHeadlinesRequest): CancelablePromise<TGetStatementHeadlinesResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/statement-headlines',
        query: req,
      })
    );
  }
}
